import React from "react";
import { Button, Snackbar } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";
import { useBuildVersionCheck } from "../hooks/useBuildVersionCheck";

/**
 * Bandeau persistant qui apparaît dès qu'un nouveau build est détecté côté
 * serveur (via `/version.txt` ≠ REACT_APP_BUILD_ID inliné). Propose de
 * recharger la page pour récupérer la dernière version.
 */
export default function UpdateAvailableBar() {
    const { t } = useTranslation();
    const updateAvailable = useBuildVersionCheck();

    if (!updateAvailable) return null;

    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            message={t(
                "app.updateAvailable",
                "Une nouvelle version est disponible."
            )}
            action={
                <Button
                    color="inherit"
                    size="small"
                    startIcon={<RefreshIcon />}
                    onClick={() => window.location.reload()}
                >
                    {t("app.reload", "Recharger")}
                </Button>
            }
        />
    );
}
